import { Marketplace } from '../marketplace';
export class Electricmeter {
    constructor(
        public id?: number,
        public marketplaceNumber?: string,
        public provider?: string,
        public count230V?: number,
        public count380V?: number,
        public owner?: string,
        public electricmeterNumber?: string,
        public location?: string,
        public updated?: any,
        public created?: any,
        public gguid?: string,
        public lastValue?: number,
        public lastValueChanged?: any,
        public marketplace?: Marketplace,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/electricmeter/electricmeter.model.ts